export default __webpack_public_path__ + "static/cnlamQrj-ddfa85de3041f8a7beb0f18c2c8f90ad.svg";